export const QuizData = [
    {
        question: "What does DOM stand for in JavaScript?",
        options: ["Document Oriented Model", "Data Object Model", "Document Object Model", "Digital Ordinance Module"],
        answer: 3
      },
      {
        question: "How do you declare a variable in JavaScript?",
        options: ["declare x;", "variable x;", "x = var;", "var x;"],
        answer: 4
      },
      {
        question: "What is the purpose of the === operator in JavaScript?",
        options: ["Strict equality comparison", "Assignment", "Type conversion", "Equality comparison"],
        answer: 1
      },
      {
        question: "How do you comment a single line in JavaScript?",
        options: ["// This is a comment", "/* This is a comment */", "<!-- This is a comment -->", "rem This is a comment"],
        answer: 1
      },
      {
        question: "Which function is used to print output in the console?",
        options: ["log()", "print()", "display()", "console.log()"],
        answer: 4
      },
      {
        question: "What is the result of typeof null in JavaScript?",
        options: ["null", " object", "undefined", "string"],
        answer: 2
      },
      {
        question: "What does the let keyword do in JavaScript?",
        options: ["Declares a variable with block scope", "Declares a variable with function scope", "Declares a constant variable", "Declares a global variable"],
        answer: 1
      },
      {
        question: "How do you check the length of an array in JavaScript?",
        options: ["array.size()", "array.length", "array.count()", "length(array)"],
        answer: 2
      },
      {
        question: "What is the purpose of the JSON.stringify() method?",
        options: ["Converts a JavaScript object to a JSON string", "Parses a JSON string to a JavaScript object", "Checks if a value is NaN", "Encodes a URL"],
        answer: 1
      },
      {
        question: "How do you create an anonymous function in JavaScript?",
        options: ["function anonymous() { }", "() => { }", "function() { }", "anonymous() = function() { }"],
        answer: 2
      },
    //   {
    //     question: "What is the purpose of the 'use strict' directive in JavaScript?",
    //     options: ["Declares a variable with strict mode", "Defines a new JavaScript version", "Allows looser variable scoping", " Enforces stricter parsing and error handling"],
    //     answer: 4
    //   },
    //   {
    //     question: "What is a closure in JavaScript?",
    //     options: ["A way to close a function", "An object with private variables", "  A global variable", "A function with access to its own scope and the scope of its containing function"],
    //     answer: 3
    //   },
    //   {
    //     question: "What is the purpose of the 'this' keyword in JavaScript?",
    //     options: ["Refers to the current HTML element", "Refers to the current JavaScript file", "Refers to the previous element", "Refers to the current object"],
    //     answer: 4
    // }
 ];